module.exports = __webpack_public_path__ + "static/media/janestreet_new.574f2a4d.jpg";